<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Mes commandes</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Liste des Achats</h3>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="sales"
            @edit="onEdit"
            @history="onHistory"
        >
          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount.toLocaleString('fr-FR') }} FCFA
          </template>

          <template #cell-saleDate="{ item }">
            {{ new Date(item.saleDate).toLocaleString() }}
          </template>

          <template #cell-reference="{ item }">
            <span class="text-primary fw-bold">{{ item.reference }}</span>
          </template>

          <template #cell-sellerName="{ item }">
            <span class="text-muted">{{ item.sellerName }}</span>
          </template>
        </TableWithFilters>
      </div>
    </div>
  </div>
</template>

<script>


  import TableWithFilters from "../../../components/TableWithFilters.vue";
  import { saleColumns,
    saleFilterableFields,
    saleRowActions} from "../../../helpers/constants";

  export default {
    name: "ShopOrders",
    components: {TableWithFilters},
    data() {
      return {
        sales: [],
        sellerId: "687c23e31e05982ddc4c2bc4", // à rendre dynamique plus tard
        columns: saleColumns,
        filterableFields: saleFilterableFields,
        rowActions: saleRowActions,
      };
    },
    methods: {
      loadSales() {
        this.$loading(true);
        this.$http
            // .get(`/sales/pending/seller/${this.sellerId}`) // prêt pour usage réel
            .get(`/sales`) // temporairement non filtré
            .then(({ data }) => {
              this.sales = data.filter(sale => sale.status === 'PENDING');
            })
            .catch(err => {
              console.error("Erreur chargement ventes :", err);
            })
            .finally(() => this.$loading(false));
      },
      onEdit(item) {
        this.$router.push({ name: "edit-sale", params: { id: item.id } });
      },
      onHistory(item) {
        this.$http.get(`/sales/${item.id}/history`)
            .then(({ data }) => {
              const html = data.map(h => `
              <li><strong>${h.status}</strong> à ${new Date(h.timestamp)}</li>
            `).join('');
              swal({
                title: `Historique de la vente #${item.id}`,
                html: `<ul style="text-align:left">${html}</ul>`,
                confirmButtonText: 'Fermer'
              });
            });
      }
    },
    mounted() {
      this.loadSales();
    }
  };
</script>

<style scoped>
.page-container {
  padding: 20px;
}
</style>
